<template>
  <component :is="view" />
</template>

<script setup>

import ListView from '@/views/ListView.vue'
// import {onBeforeMount} from 'vue'
import { loadLanguageAsync } from '@/plugins/i18n'
import {onMounted} from '@vue/runtime-core';

let view = ListView

onMounted(() =>
{
  loadLanguageAsync()
})
</script>

